import m from "../../geodata/es2015/japanHigh";
window.am4geodata_japanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/japanHigh.js
// module id = null
// module chunks = 